//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import merge from 'lodash.merge';
import keyBy from 'lodash.keyby';
import breakpoints from '~/mixins/breakpoints';
import { createEventData } from '@/utils/eventUtils';
import { mapGetters } from 'vuex';
import { processConfigurableStockStatus } from '@/utils/productUtils';

export default {
    props: ['uid'],
    mixins: [breakpoints],
    async fetch() {
        const id = this.uid;
        this.search = this.$route.query.q;
        let filter = {};

        /* Get filters and pagination params based on query filters
         * @example host:varaosat/apple/iphone-8?currentPage=1
         *  */
        filter = this.createFilterObject(this.$route.query);

        /* If filter object now has category_uid, it means client is trying to use category filters inside a category
         *  If not, client is trying to view a category page.
         *  */
        if (filter.hasOwnProperty('category_uid')) {
            filter.category_uid.in.push(id);
        } else {
            filter.category_uid = { eq: id };
        }
        const variables = {
            id,
            filter,
            currentPage: this.$route.query.currentPage ?? 1,
            sort: {
                order: 'ASC',
            },
        };

        if (this.$route.query.pageSize) {
            variables.pageSize = this.$route.query.pageSize;
        }

        if (this.$route.query.sortType && this.$route.query.sortDir) {
            const obj = {};
            obj[this.$route.query.sortType] = this.$route.query.sortDir;
            variables.sort = obj;
        }
        if (this.search || this.$route.query.hasOwnProperty('q')) {
            delete variables.id;
            delete variables.filter.q;
            variables.search = this.search;
        }

        const {
            data: { categories },
        } = await this.$axios.$get(`/category/${id || ''}`);

        const {
            data: {
                products: { aggregations, sort_fields },
            },
        } = await this.$axios.$get('/categoryfilters?', {
            params: variables,
        });

        const {
            data: {
                products: { items, total_count, page_info },
            },
        } = await this.$axios.$get(`/categoryproduct?`, {
            params: variables,
        });

        // workaround for fulltext search with empty search string
        if (!id && !this.search) {
            categories.items = [];
        }

        this.products = items.filter((item) => item !== null);

        const { data: stockData, errors: stockErrors } = await this.$axios.$get(`/category/stock/${id}`, {
            params: variables,
        });

        if (!stockErrors) {
            const stockProducts = stockData.products.items || null;
            if (this.products && stockProducts) {
                merge(keyBy(this.products, 'sku'), keyBy(stockProducts, 'sku'));
            }
        }

        this.products.forEach((product) => {
            if (product.__typename === 'ConfigurableProduct') {
                processConfigurableStockStatus(product);
            }
        });

        this.category = categories.items[0] || {};
        this.total = total_count;
        // If there are no filters(like page initial load), or no last selected attribute found in store, apply all aggregations to filters
        if (!this.filters.length || !id || !this.lastSelectedAttribute) {
            this.filters = aggregations;
        } else {
            const priceFilter = this.filters.find((filter) => filter.attribute_code === 'price');
            const newAggregations = aggregations.map((newFilter) => {
                if (newFilter.attribute_code === 'price' && filter['price']) {
                    return priceFilter;
                }
                return newFilter;
            });
            // If filters of last selected attribute are all disselected, apply all aggregations to filters
            if (!filter[this.lastSelectedAttribute]) {
                this.filters = newAggregations;
            } else {
                const filterNotTobeUpdated = this.filters.find((filter) => filter.attribute_code === this.lastSelectedAttribute);
                this.filters = newAggregations.map((newFilter) => {
                    if (newFilter.attribute_code === this.lastSelectedAttribute) {
                        return filterNotTobeUpdated;
                    }
                    return newFilter;
                });
            }
        }
        this.sorts = sort_fields;
        this.toolbar = page_info;

        if (!categories.items[0]) {
            if (!this.shownDisabledMessage) {
                this.shownDisabledMessage = true;
                this.$notify.error(this.$t('catalog.error.disabled'));
            }
            this.$nuxt.error({ statusCode: 404, message: 'Category not found' });
            throw new Error('Category not found');
        }
    },
    data() {
        return {
            products: [],
            category: {},
            total: 0,
            filters: [],
            toolbar: {},
            filtersOpen: false,
            search: '',
            shownDisabledMessage: false,
        };
    },
    fetchKey: 'category-page',
    watch: {
        '$route.query'() {
            this.shownDisabledMessage = false;
            if (this.$route.name.includes('all') || this.$route.name.includes('search')) {
                this.$fetch();
            }
        },
    },
    async mounted() {
        if (this.products.length === 0 && this.$route.query.currentPage !== '1') {
            this.$fetch();
        }

        if (this.$gtm) {
            setTimeout(() => {
                try {
                    this.$gtm.push({ ecommerce: null, items: null });
                    this.$gtm.push({
                        event: 'view_item_list',
                        ecommerce: {
                            item_list_id: this.uid,
                            item_list_name: this.category.name,
                            items: [...this.products].reduce((acc, curr) => {
                                acc.push({
                                    item_id: curr.sku,
                                    item_name: curr.name,
                                    price: curr.price_range.minimum_price.final_price.value,
                                });

                                return acc;
                            }, []),
                        },
                        items: [...this.products].reduce((acc, curr) => {
                            acc.push({
                                id: curr.sku,
                                google_business_vertical: 'retail',
                            });

                            return acc;
                        }, []),
                    });
                } catch (e) {
                    console.error(e);
                }
            }, 2000);
        }

        await this.sendViewCategoryEvent();
    },
    computed: {
        ...mapGetters({
            lastSelectedAttribute: 'attributeFilter/getLastSelectedAttribute',
        }),
        enabledFilters() {
            const enabledFilters = this.createFilterObject(this.$route.query);
            const filtersCount = Object.keys(enabledFilters).length;

            if (filtersCount === 0) {
                return '';
            }

            return `(${filtersCount})`;
        },
        descriptionMaxLength() {
            const desktopDescriptionLength = 390;
            const mobileDescriptionLength = 255;

            if (this.isXl) {
                return desktopDescriptionLength;
            } else {
                return mobileDescriptionLength;
            }
        },
    },
    methods: {
        createFilterObject(filters) {
            const sorts = ['pageSize', 'currentPage', 'sortType', 'sortDir', 'q'];

            return Object.entries(filters).reduce((result, [filterName, selected]) => {
                if (sorts.includes(filterName)) {
                    return {
                        ...result,
                    };
                }
                if (filterName === 'price' || filterName.includes('bucket') || filterName.to) {
                    let from, to;
                    if (Array.isArray(selected)) {
                        [from, to] = selected[0].split('_'); //eslint-disable-line
                    } else {
                        [from, to] = selected.split('_');
                    }
                    if (to === '*') to = '9999999999999';
                    let name = filterName;
                    if (filterName.includes('bucket')) {
                        name = filterName.replace('_bucket', '');
                    }

                    result[name] = {
                        to,
                        from,
                    };

                    return {
                        ...result,
                        [name]: {
                            to,
                            from,
                        },
                    };
                }

                return {
                    ...result,
                    [filterName]: {
                        in: selected,
                    },
                };
            }, {});
        },
        onPaginationUpdate(index) {
            const { query } = this.$route;
            delete query.currentPage;
            this.$scrollTo('#category-products');
            this.$router.push({ path: this.$route.path, query: { currentPage: index, ...query } });
        },
        getImageUrl(width, height) {
            return this.category.image ? this.$options.filters.image(this.category.image, width, height) : '/category.jpg';
        },
        async sendViewCategoryEvent() {
            try {
                let userData = null;
                const fbc = this.$storage.getCookie('_fbc');
                if (fbc) {
                    userData = {
                        fbc: fbc,
                    };
                }

                const fbp = this.$storage.getCookie('_fbp');
                if (fbp) {
                    userData = {
                        ...userData,
                        fbp: fbp,
                    };
                }

                if (this.$store.state.auth.loggedIn) {
                    let user = this.$store.state.auth.user;
                    if (user) {
                        userData = {
                            ...userData,
                            em: this.$store.state.auth.user.email,
                            fn: this.$store.state.auth.user.firstname,
                            ln: this.$store.state.auth.user.lastname,
                        };
                    }
                }

                const eventData = createEventData(
                    'ViewCategory',
                    null,
                    {
                        name: this.category.name,
                    },
                    userData,
                );
                await this.$store.dispatch('eventTracking/sendEventData', { eventData });
            } catch (e) {
                console.error(e);
            }
        },
    },
    head() {
        let collectionJson = {};
        let breadCrumbJson = {};
        if (!this.$fetchState.pending && !this.$fetchState.error && this.category.name) {
            let description = '';
            if (this.category.description) {
                description = this.category.description.replace(/(<([^>]+)>)/gi, '');
            }

            collectionJson = {
                '@context': 'https://schema.org',
                '@type': 'CollectionPage',
                'name': this.category.name,
                description,
                'url': 'https://mobiilitukku.fi/' + this.category.url_path,
                'mainEntity': {
                    '@type': 'ItemList',
                    'itemListElement': this.products.map((product, index) => {
                        return {
                            '@type': 'ListItem',
                            'position': index + 1,
                            'url': 'https://mobiilitukku.fi/' + product.url_key,
                        }
                    })
                }
            };

            let categoryBreadCrumbs = [];
            if (this.category.breadcrumbs !== null) {
                categoryBreadCrumbs = this.category.breadcrumbs.map((breadcrumb) => {
                    return {
                        '@type': 'ListItem',
                        'position': breadcrumb.category_level,
                        'name': breadcrumb.category_name,
                        'item': 'https://mobiilitukku.fi/' + breadcrumb.category_url_path
                    }
                });
            }

            categoryBreadCrumbs.unshift({
                '@type': 'ListItem',
                'position': 1,
                'name': this.category.name,
                'item': 'https://mobiilitukku.fi/'
            })

            categoryBreadCrumbs.push({
                '@type': 'ListItem',
                'position': categoryBreadCrumbs.length + 1,
                'name': this.category.name,
                'item': 'https://mobiilitukku.fi/' + this.category.url_path
            });

            breadCrumbJson = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                'itemListElement': categoryBreadCrumbs
            }
        }

        const structuredDataScript =
            [
                {
                    type: 'application/ld+json',
                    json: collectionJson,
                },
                {
                    type: 'application/ld+json',
                    json: breadCrumbJson,
                },
            ];

        return {
            title: this.search ? `${this.$t('navigation.title')}: "${this.search}"` : this.category.meta_title,
            titleTemplate: '%s',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: (this.category || (!this.$fetchState.pending && !this.$fetchState.error)) && this.category.meta_description,
                },
                {
                    hid: 'og:description',
                    name: 'og:description',
                    content: (this.category || (!this.$fetchState.pending && !this.$fetchState.error)) && this.category.meta_description,
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.search ? `${this.$t('navigation.title')}: "${this.search}"` : this.category.meta_title,
                },
                {
                    hid: 'og:image',
                    name: 'og:image',
                    content: this.category && !this.$fetchState.pending && !this.$fetchState.error && (this.category.image || `/category.jpg`),
                },
            ],
            script: structuredDataScript,
        };
    },
};
